import { ReportHandler } from 'web-vitals';

/**
 * Report Web Vitals performance metrics
 * 
 * SECURITY: No console logging - metrics are passed to callback only
 * PERFORMANCE: Uses dynamic import to code-split web-vitals library
 * 
 * @param onPerfEntry - Optional callback to handle performance metrics
 */
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // PERFORMANCE: Dynamic import prevents web-vitals from blocking initial load
    // Only loads when callback is provided and metrics are needed
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // SECURITY: Metrics are passed to callback only, no console logging
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    }).catch(() => {
      // SECURITY: Silent fail - don't log errors to prevent information leakage
      // Web vitals are non-critical, so failures shouldn't affect app functionality
    });
  }
};

export default reportWebVitals; 